import React, { useState, useEffect } from 'react';
import {
  Input,
  InputNumber,
  Select,
  Form,
  Button,
  Modal,
  Tooltip,
  Table,
  Cascader,
  Spin,
  Typography,
  Tag as AntdTag,
} from 'antd';
import cx from 'classnames';
import styles from './addnewurlfeed.module.sass';
import { STATUS } from '../../../redux/constants';
import { EditOutlined } from '@ant-design/icons';
import tagStyles from '../../../shared-components/Tag/tag.module.sass';
import GeneralTagMultipleSelect from '../../../shared-components/GeneralTagMultipleSelect';
import { incrementUIRequestsCounter } from '../../../redux/utils/websocket/incrementUIRequestsCounter';
import { useDispatch } from 'react-redux';

function CreateURLFeedModal(props) {
  const [form] = Form.useForm();
  const [columnMap, setColumnMap] = useState({});
  const [selectedMapping, setSelectedMapping] = useState(false);
  const [showMappingStepURL, setShowMappingStepURL] = useState(false);
  const [enableSaveButton, setEnableSaveButton] = useState(false);
  const [enableConsumeButton, setEnableConsumeButton] = useState(false);
  const [showSaveButton, setShowSaveButton] = useState(true);
  const [authorization, setAuthorization] = useState(null);
  const [enableEditURL, setEnableEditURL] = useState(false);
  const [enableTestButton, setEnableTestButton] = useState(false);
  const [editingTags, setEditingTags] = useState(false);
  const [renderTags, setRenderTags] = useState(false);
  const { Text, Paragraph, Title } = Typography;
  const dispatch = useDispatch();

  useEffect(() => {
    if (Object.keys(props?.selectedSourceToEdit).length > 0) {
      setRenderTags(false);
    } else {
      setRenderTags(true);
    }
  }, []);

  useEffect(() => {
    if (Object.keys(props?.selectedSourceToEdit).length > 0) {
      form.setFieldsValue(loadInitialValues());
      if (props?.selectedSourceToEdit?.tags) {
        sessionStorage.setItem(
          'tags',
          JSON?.stringify(props?.selectedSourceToEdit?.tags?.map((tag) => tag)),
        );
      } else {
        sessionStorage.setItem('tags', []);
      }
      setRenderTags(true);
    }
  }, [props?.selectedSourceToEdit]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (
      props?.feedTable?.resource_type === 'STIX' ||
      props?.feedTable?.resource_type === 'THREATCONNECT' ||
      props?.feedTable?.resource_type === 'CROWDSTRIKE'
    )
      setEnableSaveButton(true);
  }, [props?.feedTable]);

  const authorizationOptions = [
    {
      value: null,
      label: 'Not Required',
    },
    {
      value: 'BASIC',
      label: 'Basic',
    },
    {
      value: 'TOKEN',
      label: 'Token',
    },
    {
      value: 'THREATCONNECT_API',
      label: 'ThreatConnect API',
    },
    {
      value: 'CROWDSTRIKE_API',
      label: 'CrowdStrike API',
    },
    {
      value: 'CUSTOM',
      label: 'Custom Header',
      children: [
        {
          value: 'x-api-key',
          label: 'x-api-key',
        },
        {
          value: 'api-key',
          label: 'api-key',
        },
        {
          value: 'api_key',
          label: 'api_key',
        },
      ],
    },
  ];

  const CreateURLFeed = (formValues) => {
    const columnMapData = {};
    Object.keys(columnMap).forEach((col) => {
      const mappingColumn = columnMap[col];
      columnMapData[mappingColumn.name] = {
        name: mappingColumn.mapping,
        order: +col,
      };
    });

    let data = {
      state: props.state.toUpperCase(),
      name: formValues.feed_name,
      threat_type: formValues.feed_type,
      resource_url: formValues.feed_url,
      custom_score: formValues.feed_custom_score,
      ...(formValues.feed_vendor && { feed_vendor: formValues.feed_vendor }),
      auth_config:
        authorization && authorization !== 'CUSTOM'
          ? {
              type: authorization,
              username: formValues.username,
              password: formValues.password,
              token: formValues.token,
              threatconnect_id: formValues.threatconnect_id,
              threatconnect_secret: formValues.threatconnect_secret,
              crowdstrike_id: formValues.crowdstrike_id,
              crowdstrike_user_agent: formValues.crowdstrike_user_agent,
              crowdstrike_secret: formValues.crowdstrike_secret,
            }
          : null,
      vendor: formValues.feed_vendor,
      feed_description: formValues.feed_description,
      column_mapping: columnMapData,
      resource_type: formValues.resource_type,
      // tags: JSON.parse(sessionStorage.getItem('tags')),
      ...(form?.getFieldValue('authorization')[1] === 'x-api-key' && {
        advanced_options: {
          request_method: 'GET',
          headers: {
            'x-api-key': form?.getFieldValue('custom_api_key'),
          },
        },
      }),
      ...(form?.getFieldValue('authorization')[1] === 'api-key' && {
        advanced_options: {
          request_method: 'GET',
          headers: {
            'api-key': form?.getFieldValue('custom_api_key'),
          },
        },
      }),
      ...(form?.getFieldValue('authorization')[1] === 'api_key' && {
        advanced_options: {
          request_method: 'GET',
          headers: {
            api_key: form?.getFieldValue('custom_api_key'),
          },
        },
      }),
    };
    if (sessionStorage?.getItem('tags')) {
      data = { ...data, tags: JSON.parse(sessionStorage?.getItem('tags')) };
    }
    props.createURLSource(data);
  };

  const updateFeed = (formValues) => {
    let data = {
      uuid: props.selectedSourceToEdit?.uuid,
      name: formValues.feed_name,
      custom_score: formValues.feed_custom_score,
      vendor: formValues.feed_vendor,
      feed_description: formValues.feed_description,
    };
    if (Object.keys(props.selectedSourceToEdit).length > 0 && enableEditURL) {
      const columnMapData = {};
      Object.keys(columnMap).forEach((col) => {
        const mappingColumn = columnMap[col];
        columnMapData[mappingColumn.name] = {
          name: mappingColumn.mapping,
          order: +col,
        };
      });
      data = {
        ...data,
        column_mapping: columnMapData,
        resource_url: formValues.feed_url,
        resource_type: formValues.resource_type,
      };
      if (authorization && authorization !== 'CUSTOM') {
        data = {
          ...data,
          auth_config: {
            type: authorization,
            username: formValues.username,
            password: formValues.password,
            token: formValues.token,
            threatconnect_id: formValues.threatconnect_id,
            threatconnect_secret: formValues.threatconnect_secret,
            crowdstrike_id: formValues.crowdstrike_id,
            crowdstrike_user_agent: formValues.crowdstrike_user_agent,
            crowdstrike_secret: formValues.crowdstrike_secret,
          },
        };
      }

      if (form?.getFieldValue('authorization')[1] === 'x-api-key') {
        data = {
          ...data,
          advanced_options: {
            request_method: 'GET',
            headers: {
              'x-api-key': form?.getFieldValue('custom_api_key'),
            },
          },
        };
      }

      if (form?.getFieldValue('authorization')[1] === 'api-key') {
        data = {
          ...data,
          advanced_options: {
            request_method: 'GET',
            headers: {
              'api-key': form?.getFieldValue('custom_api_key'),
            },
          },
        };
      }

      if (form?.getFieldValue('authorization')[1] === 'api_key') {
        data = {
          ...data,
          advanced_options: {
            request_method: 'GET',
            headers: {
              api_key: form?.getFieldValue('custom_api_key'),
            },
          },
        };
      }
    }
    data = { ...data, tags: JSON.parse(sessionStorage?.getItem('tags')) };
    props.updateURLSource(data);
  };

  const onSave = () => {
    let formValues = form.getFieldsValue();
    if (Object.keys(props.selectedSourceToEdit).length > 0) {
      updateFeed(formValues);
      props.onUpdate();
    } else {
      CreateURLFeed(formValues);
      props.onCreate();
    }
    incrementUIRequestsCounter();
  };

  const handleContainerClick = () => {
    setEditingTags(true);
    onInputChange();
  };

  const handleRemoveTagClick = (tagName) => {
    let updatedTags = JSON.parse(sessionStorage?.getItem('tags'))?.filter(
      (tag) => tag !== tagName,
    );
    sessionStorage.setItem('tags', JSON.stringify(updatedTags));
    onInputChange();
  };

  const handleBlur = () => {
    props.resetTagSearch();
    setEditingTags(false);
  };

  const onConsume = () => {
    const url = form.getFieldValue('feed_url');
    const username = form.getFieldValue('username');
    const password = form.getFieldValue('password');
    const token = form.getFieldValue('token');
    const threatconnect_id = form.getFieldValue('threatconnect_id');
    const threatconnect_secret = form.getFieldValue('threatconnect_secret');
    const crowdstrike_id = form.getFieldValue('crowdstrike_id');
    const crowdstrike_user_agent = form.getFieldValue('crowdstrike_user_agent');
    const crowdstrike_secret = form.getFieldValue('crowdstrike_secret');
    const type = form.getFieldValue('resource_type');
    const threat_type = form.getFieldValue('feed_type');
    const custom_api_key_type = form.getFieldValue('authorization')[1];
    const custom_api_key_value = form.getFieldValue('custom_api_key');

    props.consumeFeedData({
      state: props.state.toUpperCase(),
      url,
      username,
      password,
      token,
      threatconnect_id,
      threatconnect_secret,
      crowdstrike_id,
      crowdstrike_user_agent,
      crowdstrike_secret,
      authorization,
      type,
      threat_type,
      custom_api_key_type,
      custom_api_key_value,
    });

    setShowMappingStepURL(true);
    setSelectedMapping(false);
    setEnableConsumeButton(false);
    setEnableSaveButton(false);
    setShowSaveButton(true);
  };

  const onInputChange = () => {
    let feed_name = form.getFieldValue('feed_name');
    let feed_type = form.getFieldValue('feed_type');
    let feed_url = form.getFieldValue('feed_url');
    let resource_type = form.getFieldValue('resource_type');
    let authorization = form.getFieldValue('authorization');
    if (Object.keys(props.selectedSourceToEdit).length > 0) {
      if (enableEditURL) {
        if (
          feed_name &&
          feed_type &&
          feed_url &&
          resource_type &&
          authorization
        ) {
          if (selectedMapping) {
            setEnableConsumeButton(false);
            setEnableSaveButton(true);
            setShowSaveButton(true);
          } else {
            setEnableConsumeButton(true);
            setEnableSaveButton(false);
            setShowSaveButton(false);
          }
          setEnableTestButton(true);
        } else {
          setEnableConsumeButton(false);
          setEnableSaveButton(false);
          setShowSaveButton(true);
        }
      } else {
        if (feed_name) {
          setEnableSaveButton(true);
        } else {
          setEnableSaveButton(false);
        }
        setEnableConsumeButton(false);
        setShowSaveButton(true);
      }
    } else {
      if (
        feed_name &&
        feed_type &&
        feed_url &&
        resource_type &&
        authorization
      ) {
        setEnableTestButton(true);
        if (selectedMapping) {
          setEnableSaveButton(true);
          setShowSaveButton(true);
          setEnableConsumeButton(false);
        } else {
          setShowSaveButton(false);
          setEnableConsumeButton(true);
          setEnableSaveButton(false);
        }
      } else {
        setEnableConsumeButton(false);
        setShowSaveButton(true);
        setEnableSaveButton(false);
        setEnableTestButton(false);
      }
    }
  };

  const onTest = () => {
    const url = form.getFieldValue('feed_url');
    const username = form.getFieldValue('username');
    const password = form.getFieldValue('password');
    const token = form.getFieldValue('token');
    const threatconnect_id = form.getFieldValue('threatconnect_id');
    const threatconnect_secret = form.getFieldValue('threatconnect_secret');
    const crowdstrike_id = form.getFieldValue('crowdstrike_id');
    const crowdstrike_user_agent = form.getFieldValue('crowdstrike_user_agent');
    const crowdstrike_secret = form.getFieldValue('crowdstrike_secret');
    const custom_api_key_type = form.getFieldValue('authorization')[1];
    const custom_api_key_value = form.getFieldValue('custom_api_key');

    form.validateFields().then(() => {
      props.verifyAuth({
        url,
        username,
        password,
        token,
        threatconnect_id,
        threatconnect_secret,
        crowdstrike_id,
        crowdstrike_user_agent,
        crowdstrike_secret,
        authorization,
        custom_api_key_type,
        custom_api_key_value,
      });
    });
  };

  const getColumns = () => {
    const { feedTable, feedItemFields } = props;
    const rows = feedTable?.rows;
    const firstRow = rows[0];
    const hasHeader = feedTable?.has_header;
    let originalColumns = [];
    if (hasHeader) {
      originalColumns = firstRow;
    }

    const columns = firstRow?.map((text, index, cols) => {
      const col = {
        dataIndex: index,
        key: index,
        render: (text) => (
          <Tooltip title={text?.length >= 27 ? text : ''}>
            <span>
              {text?.length >= 27 ? text?.substring(0, 24) + '...' : text}
            </span>
          </Tooltip>
        ),
        title: (filters, sortOrder) => (
          <Select
            placeholder="Select To Map Column"
            defaultActiveFirstOption
            options={feedItemFields}
            onChange={(value) =>
              handleColumnChange(value, index, originalColumns)
            }
          />
        ),
      };
      return col;
    });

    return columns;
  };

  const getData = () => {
    const { feedTable } = props;
    const rows = feedTable.rows.slice(0, 5);

    const data = rows.map((row) => {
      const item = {};
      row.forEach((text, index) => {
        if (typeof text === 'object' && text !== null) {
          item[index] = text?.date;
        } else {
          item[index] = text;
        }
      });
      return item;
    });

    return data;
  };

  const handleColumnChange = (value, index, originalColumns) => {
    const _columnMap = columnMap;
    if (!value) {
      delete _columnMap[index];
      setEnableSaveButton(false);
      setShowSaveButton(false);
    } else {
      setEnableSaveButton(true);
      setShowSaveButton(true);
      const mappedValue = { name: value, mapping: value };
      if (originalColumns && index < originalColumns.length) {
        mappedValue.mapping = originalColumns[index];
      }
      _columnMap[index] = mappedValue;
    }
    setColumnMap(_columnMap);
    setSelectedMapping(true);
  };

  const renderMappingStepURL = () => {
    let columns;
    let data;
    if (!props.feedTable.rows?.length) return null;

    if (
      !(
        props?.feedTable?.resource_type === 'STIX' ||
        props?.feedTable?.resource_type === 'THREATCONNECT' ||
        props?.feedTable?.resource_type === 'CROWDSTRIKE'
      )
    ) {
      columns = getColumns();
      data = getData();
    }
    return (
      <div hidden={!showMappingStepURL}>
        {!(
          props?.feedTable?.resource_type === 'STIX' ||
          props?.feedTable?.resource_type === 'THREATCONNECT' ||
          props?.feedTable?.resource_type === 'CROWDSTRIKE'
        ) ? (
          <>
            <Text>
              Map correct columns in the table with your source (file, URL).
              Only one column per entity (domain, IP, URL and tags) is allowed.
              Make sure to match observables type from file with feed/collection
              type you choose.
            </Text>
            <br />
            <Table columns={columns} dataSource={data} pagination={false} />
          </>
        ) : props.feedTable?.resource_type === 'STIX' ? (
          <Paragraph>
            STIX is detected and mapping is ready. Click consume button to
            upload the file.
          </Paragraph>
        ) : props.feedTable?.resource_type === 'THREATCONNECT' ? (
          <Paragraph>
            Threatconnect structure detected, mapping ready. Click save to
            upload.
          </Paragraph>
        ) : props.feedTable?.resource_type === 'CROWDSTRIKE' ? (
          <Paragraph>
            CrowdStrike structure detected, mapping ready. Click save to upload.
          </Paragraph>
        ) : (
          ''
        )}
      </div>
    );
  };

  const loadInitialValues = () => {
    let initialValues = {
      feed_name: props?.selectedSourceToEdit?.name,
      feed_type: props?.selectedSourceToEdit?.type,
      feed_vendor: props?.selectedSourceToEdit?.vendor,
      feed_description: props?.selectedSourceToEdit?.feed_description,
      feed_url: props?.selectedSourceToEdit?.url,
      feed_custom_score: props?.selectedSourceToEdit?.custom_score,
    };
    if (Object.keys(props.selectedSourceToEdit).length === 0) {
      initialValues = {
        ...initialValues,
        authorization: [null],
      };
    }
    return initialValues;
  };

  const isURLEditEnabled = () => {
    return (
      Object.keys(props.selectedSourceToEdit).length === 0 || enableEditURL
    );
  };

  const onEditIconClick = () => {
    if (enableEditURL) {
      form.setFieldsValue({
        feed_url: props?.selectedSourceToEdit?.url,
      });

      let feed_name = form.getFieldValue('feed_name');
      let feed_vendor = form.getFieldValue('feed_vendor');
      let feed_description = form.getFieldValue('feed_description');
      let feed_custom_score = form.getFieldValue('feed_custom_score');

      let original_feed_name = props.selectedSourceToEdit?.name;
      let original_feed_vendor = props.selectedSourceToEdit?.vendor;
      let original_feed_description =
        props.selectedSourceToEdit?.feed_description;
      let original_feed_custom_score = props.selectedSourceToEdit?.custom_score;

      if (
        feed_name &&
        (feed_name !== original_feed_name ||
          feed_vendor !== original_feed_vendor ||
          feed_description !== original_feed_description ||
          feed_custom_score !== original_feed_custom_score)
      ) {
        setEnableSaveButton(true);
      } else {
        setEnableSaveButton(false);
      }
      setEnableConsumeButton(false);
      setShowSaveButton(true);
    } else {
      setEnableSaveButton(false);
    }
    setEnableEditURL(!enableEditURL);
  };

  const getSaveButtonName = () => {
    if (Object.keys(props.selectedSourceToEdit).length === 0) {
      return 'Create';
    }
    return 'Save';
  };

  const getModalTitle = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      if (Object.keys(props.selectedSourceToEdit).length > 0) {
        return 'Edit collection';
      }
      return 'Create collection from URL';
    } else {
      if (Object.keys(props.selectedSourceToEdit).length > 0) {
        return 'Edit feed';
      }
      return 'Create feed from URL';
    }
  };

  const getSourceNameFieldName = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Collection name';
    }
    return 'Feed name';
  };

  const getSourceNameFieldPlaceHolder = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Enter collection name';
    }
    return 'Enter feed name';
  };

  const getSourceTypeFieldName = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Collection type';
    }
    return 'Feed type';
  };

  const getSourceTypeFieldPlaceHolder = () => {
    if (props?.state.toUpperCase() === 'COLLECTION') {
      return 'Select collection type';
    }
    return 'Select feed type';
  };

  const renderContent = () => {
    return (
      <Modal
        title={getModalTitle()}
        visible={true}
        maskClosable={false}
        ű
        onCancel={() => props.onCancel()}
        width={1000}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              props.onCancel();
            }}
          >
            Cancel
          </Button>,
          <Button
            disabled={!enableSaveButton}
            hidden={!showSaveButton}
            type="primary"
            onClick={onSave}
          >
            {getSaveButtonName()}
          </Button>,
          <Button
            disabled={!enableConsumeButton}
            hidden={showSaveButton}
            type="primary"
            htmlType="submit"
            onClick={onConsume}
          >
            Consume
          </Button>,
        ]}
      >
        <Form form={form} name="feed" className={styles.add_new_url_feed}>
          <div className={styles.flex_container}>
            <Form.Item
              name="feed_name"
              label={getSourceNameFieldName()}
              rules={[
                {
                  required: true,
                  message: 'Name is a required field.',
                },
              ]}
            >
              <Input
                maxLength={150}
                onChange={() => onInputChange()}
                placeholder={getSourceNameFieldPlaceHolder()}
              />
            </Form.Item>

            <Form.Item
              name="feed_type"
              label={getSourceTypeFieldName()}
              rules={[
                {
                  required: true,
                  message: 'Type is a required field.',
                },
              ]}
            >
              <Select
                allowClear
                placeholder={getSourceTypeFieldPlaceHolder()}
                onChange={() => onInputChange()}
                disabled={Object.keys(props.selectedSourceToEdit).length > 0}
              >
                <Select.Option value="ip">IP</Select.Option>
                <Select.Option value="domain">Domain</Select.Option>
                <Select.Option value="url">URL</Select.Option>
              </Select>
            </Form.Item>
          </div>

          <div className={styles.flex_container}>
            <Form.Item
              name="feed_vendor"
              label="Vendor"
              rules={[
                {
                  required: false,
                  message: 'Please input the vendor name!',
                },
              ]}
            >
              <Input
                maxLength={250}
                onChange={() => onInputChange()}
                placeholder="Enter Vendor Name"
              />
            </Form.Item>

            <Form.Item
              name="feed_custom_score"
              label="Source Score (0-100)"
              rules={[
                {
                  required: false,
                  message: 'Source score is a required field.',
                },
              ]}
            >
              <InputNumber
                min={0}
                max={100}
                onChange={() => onInputChange()}
                placeholder="Enter Source Score"
              />
            </Form.Item>
          </div>

          <Form.Item
            name="feed_description"
            label="Description"
            rules={[
              {
                required: false,
                message: 'Please input the description!',
              },
            ]}
          >
            <Input.TextArea
              rows={4}
              maxLength={3000}
              onChange={() => onInputChange()}
              placeholder="Enter Description"
            />
          </Form.Item>

          {renderTags ? (
            <div className={styles.tag_list}>
              {editingTags ? (
                <>
                  {sessionStorage?.getItem('tags')
                    ? JSON.parse(sessionStorage?.getItem('tags'))?.map(
                        (tag) => {
                          return (
                            <AntdTag
                              key={`${Math.random()}`}
                              onClose={() => handleRemoveTagClick(tag)}
                              className={cx(styles?.manually_tag)}
                              closable={true}
                            >
                              {tag?.name ? tag?.name : tag}
                            </AntdTag>
                          );
                        },
                      )
                    : ''}
                  <GeneralTagMultipleSelect
                    foundTags={props?.foundTags}
                    searchStatus={props?.searchStatus}
                    searchForTags={props?.searchForTags}
                    onBlur={() => handleBlur()}
                    clearValue
                  />
                </>
              ) : (
                <>
                  {sessionStorage?.getItem('tags')
                    ? JSON.parse(sessionStorage?.getItem('tags'))?.map(
                        (tag) => {
                          return (
                            <AntdTag
                              key={`${Math.random()}`}
                              onClose={() => handleRemoveTagClick(tag)}
                              className={cx(styles?.manually_tag)}
                              closable={true}
                            >
                              {tag?.name ? tag?.name : tag}
                            </AntdTag>
                          );
                        },
                      )
                    : ''}
                  <AntdTag
                    role={'button13'}
                    className={cx(tagStyles?.tag, styles?.add_tag_button)}
                    onClick={() => handleContainerClick()}
                  >
                    + Add Tag
                  </AntdTag>
                </>
              )}
            </div>
          ) : (
            ''
          )}

          {Object.keys(props.selectedSourceToEdit).length > 0 ? (
            <Button onClick={onEditIconClick}>
              <EditOutlined />
              Edit
            </Button>
          ) : (
            ''
          )}

          <div>
            {props?.consumeStatus === STATUS.LOADED ? (
              renderMappingStepURL()
            ) : (
              <Spin hidden={!showMappingStepURL} />
            )}

            <div hidden={showMappingStepURL}>
              <div className={cx(styles.flex_container, styles.triple)}>
                <Form.Item
                  name="feed_url"
                  label="URL"
                  onChange={() => onInputChange()}
                  rules={[
                    {
                      required: true,
                      message: 'Please input the URL!',
                    },
                  ]}
                >
                  <Input
                    maxLength={10000}
                    disabled={!isURLEditEnabled()}
                    placeholder="Enter URL"
                  />
                </Form.Item>

                <Form.Item
                  name="resource_type"
                  label="Source Format"
                  rules={[
                    {
                      required: true,
                      message: 'Please input the source format!',
                    },
                  ]}
                >
                  <Select
                    allowClear
                    onChange={() => onInputChange()}
                    disabled={!isURLEditEnabled()}
                    placeholder="Enter Source Format"
                  >
                    <Select.Option value="JSON">JSON</Select.Option>
                    <Select.Option value="CSV">CSV</Select.Option>
                    <Select.Option value="TXT">TXT</Select.Option>
                  </Select>
                </Form.Item>

                <Form.Item name="authorization" label="Authorization">
                  <Cascader
                    disabled={!isURLEditEnabled()}
                    onChange={() => {
                      setAuthorization(form.getFieldValue('authorization')[0]);
                      onInputChange();
                    }}
                    options={authorizationOptions}
                    placeholder="Authentication"
                  />
                </Form.Item>
              </div>

              {authorization === 'BASIC' && (
                <>
                  <Form.Item
                    name="username"
                    label="Username"
                    rules={[
                      { required: true, message: 'Username is required' },
                    ]}
                  >
                    <Input placeholder="Enter Username" />
                  </Form.Item>

                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      { required: true, message: 'Password is required' },
                    ]}
                  >
                    <Input placeholder="Enter Password" />
                  </Form.Item>
                </>
              )}

              {authorization === 'TOKEN' && (
                <>
                  <Form.Item
                    name="token"
                    label="Token"
                    rules={[{ required: true, message: 'Token is required' }]}
                  >
                    <Input placeholder="Enter Token" />
                  </Form.Item>
                </>
              )}

              {authorization === 'THREATCONNECT_API' && (
                <>
                  <Form.Item
                    name="threatconnect_id"
                    label="Threatconnect ID"
                    rules={[{ required: true, message: 'ID is required' }]}
                  >
                    <Input placeholder="Enter Threatconnect ID" />
                  </Form.Item>

                  <Form.Item
                    name="threatconnect_secret"
                    rules={[{ required: true, message: 'Secret is required' }]}
                  >
                    <Input placeholder="Enter Threatconnect Secret" />
                  </Form.Item>
                </>
              )}

              {authorization === 'CROWDSTRIKE_API' && (
                <>
                  <Form.Item
                    name="crowdstrike_id"
                    label="CrowdStrike ID"
                    rules={[{ required: true, message: 'ID is required' }]}
                  >
                    <Input placeholder="Enter CrowdStrike ID" />
                  </Form.Item>

                  <Form.Item
                    name="crowdstrike_user_agent"
                    label="CrowdStrike User Agent"
                    rules={[
                      { required: true, message: 'User Agent is required' },
                    ]}
                  >
                    <Input placeholder="Enter CrowdStrike User Agent" />
                  </Form.Item>

                  <Form.Item
                    name="crowdstrike_secret"
                    label="CrowdStrike Secret"
                    rules={[{ required: true, message: 'Secret is required' }]}
                  >
                    <Input placeholder="Enter CrowdStrike Secret" />
                  </Form.Item>
                </>
              )}

              {authorization === 'CUSTOM' && (
                <>
                  <Form.Item
                    name="custom_api_key"
                    label="API Key"
                    rules={[{ required: true, message: 'API Key is required' }]}
                  >
                    <Input maxLength={255} placeholder="Enter API Key" />
                  </Form.Item>
                </>
              )}
              <Form.Item>
                <Button
                  style={{
                    color: 'rgb(60, 154, 232)',
                    border: !enableTestButton
                      ? '1px solid #595959'
                      : '1px solid rgb(60, 154, 232)',
                  }}
                  role={'button14'}
                  disabled={!enableTestButton}
                  onClick={() => onTest()}
                  loading={props.testStatus === STATUS.RUNNING}
                >
                  Test Access
                </Button>
              </Form.Item>
            </div>
          </div>
        </Form>
      </Modal>
    );
  };

  return <>{renderContent()}</>;
}

export default CreateURLFeedModal;
